const state = {
    core: {},
    searchObjects: {},
    authenticated: false,
    loginUrl: null,
    resendUrl: null,
    credentials: null
}

const getters = {
    get: state => state.core,
    searchObjects: state => state.searchObjects,
    authenticated: state => state.authenticated,
    loginUrl: state => state.loginUrl,
    resendUrl: state => state.resendUrl,
    credentials: state => state.credentials,
    preferredTier: state => state.core.preferredTier
}

const mutations = {
    setCore(state, core) {
        state.core = core
        state.searchObjects = {
            application: _.get(core, "application", {}),
            applicant: _.get(core, "applicant", {}),
            asset: _.get(core, "asset", {}),
            aai: _.get(core, "aai", {}),
            custom: _.get(core, "custom_values", {}),
        }
    },
    setAuthenticated(state, authenticated) {
        state.authenticated = authenticated
    },
    setLoginUrl(state, loginUrl) {
        state.loginUrl = loginUrl
    },
    setResendUrl(state, resendUrl) {
        state.resendUrl = resendUrl
    },
    setCredentials(state, credentials) {
        state.credentials = credentials
    },
    updateApplication(state, application) {
        state.core.application = application
        state.searchObjects.application = application
    },
    updateCustomFields(state, customFields) {
        state.core.customFields = customFields
    },
    setPreferredTier(state, preferredTier) {
        state.core.preferredTier = preferredTier
    },
    updateObjectives(state, objectives) {
        state.core.objectives = objectives
    },
    setFastTrackActive(state, fastTrackActive) {
        state.core.application.fast_track_active = fastTrackActive
    },
}

const actions = {
    set({ commit }, core) {
        commit("setCore", core)
    },
    setAuthenticated({ commit }, authenticated) {
        commit("setAuthenticated", authenticated)
    },
    setLoginUrl({ commit }, loginUrl) {
        commit("setLoginUrl", loginUrl)
    },
    setResendUrl({ commit }, resendUrl) {
        commit("setResendUrl", resendUrl)
    },
    setCredentials({ commit }, credentials) {
        commit("setCredentials", credentials)
    },
    updateApplication({ commit }, application) {
        commit("updateApplication", application)
    },
    updateCustomFields({ commit }, customFields) {
        commit("updateCustomFields", customFields)
    },
    setPreferredTier({ commit, dispatch }, preferredTier) {
        commit("setPreferredTier", preferredTier)
    },
    updateObjectives({ commit, dispatch }, objectives) {
        commit("updateObjectives", objectives)
    },
    setFastTrackActive({ commit, dispatch }, fastTrackActive) {
        commit("setFastTrackActive", fastTrackActive)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
